#import '../../../../../core-entity/graphql/fragments/core-entity-task-fragment.graphql'

mutation MarkUnhelpfulAndDeleteTask($input: TaskMarkUnhelpfulAndDeleteInput!) {
    taskMarkUnhelpfulAndDelete(input: $input) {
        task {
            ...CoreEntityTaskFragment
        }
    }
}
